<template>
  <article class="page" :class="{ 'full-width': fullWidth }">
    <div class="page__header">
      <a class="page__button" target="_blank" :href="page.url">
        <svg width="50pt" height="50pt" viewBox="0 0 50 50" version="1.1">
          <path
            d="M 28.125 6.25 L 28.125 9.375 L 38.414063 9.375 L 18.824219 28.980469 L 21.019531 31.175781 L 40.625 11.585938 L 40.625 21.875 L 43.75 21.875 L 43.75 6.25 Z M 12.5 12.5 C 9.046875 12.5 6.25 15.296875 6.25 18.75 L 6.25 37.5 C 6.25 40.953125 9.046875 43.75 12.5 43.75 L 31.25 43.75 C 34.703125 43.75 37.5 40.953125 37.5 37.5 L 37.5 21.875 L 34.375 25 L 34.375 37.5 C 34.375 39.222656 32.972656 40.625 31.25 40.625 L 12.5 40.625 C 10.777344 40.625 9.375 39.222656 9.375 37.5 L 9.375 18.75 C 9.375 17.027344 10.777344 15.625 12.5 15.625 L 25 15.625 L 28.125 12.5 Z "
          />
        </svg>
      </a>
      <a class="page__searchbar" target="_blank" :href="page.url">
        {{ page.name }}
      </a>
      <a class="page__button" @click="toggleFullWidth" v-if="!isMobile">
        <svg width="50pt" height="50pt" viewBox="0 0 50 50" version="1.1">
          <path
            title="Expand"
            v-if="!fullWidth"
            d="M 5 5 L 5 16 C 4.988281 16.722656 5.367188 17.390625 5.992188 17.753906 C 6.613281 18.121094 7.386719 18.121094 8.007813 17.753906 C 8.632813 17.390625 9.011719 16.722656 9 16 L 9 11.828125 L 18.585938 21.414063 C 19.085938 21.9375 19.832031 22.148438 20.535156 21.964844 C 21.234375 21.78125 21.78125 21.234375 21.964844 20.535156 C 22.148438 19.832031 21.9375 19.085938 21.414063 18.585938 L 11.828125 9 L 16 9 C 16.722656 9.011719 17.390625 8.632813 17.753906 8.007813 C 18.121094 7.386719 18.121094 6.613281 17.753906 5.992188 C 17.390625 5.367188 16.722656 4.988281 16 5 Z M 34 5 C 33.277344 4.988281 32.609375 5.367188 32.246094 5.992188 C 31.878906 6.613281 31.878906 7.386719 32.246094 8.007813 C 32.609375 8.632813 33.277344 9.011719 34 9 L 38.171875 9 L 28.585938 18.585938 C 28.0625 19.085938 27.851563 19.832031 28.035156 20.535156 C 28.21875 21.234375 28.765625 21.78125 29.464844 21.964844 C 30.167969 22.148438 30.914063 21.9375 31.414063 21.414063 L 41 11.828125 L 41 16 C 40.988281 16.722656 41.367188 17.390625 41.992188 17.753906 C 42.613281 18.121094 43.386719 18.121094 44.007813 17.753906 C 44.632813 17.390625 45.011719 16.722656 45 16 L 45 5 Z M 19.960938 27.980469 C 19.441406 27.996094 18.949219 28.214844 18.585938 28.585938 L 9 38.171875 L 9 34 C 9.007813 33.460938 8.796875 32.941406 8.414063 32.558594 C 8.03125 32.175781 7.511719 31.964844 6.96875 31.972656 C 5.867188 31.988281 4.984375 32.894531 5 34 L 5 45 L 16 45 C 16.722656 45.011719 17.390625 44.632813 17.753906 44.007813 C 18.121094 43.386719 18.121094 42.613281 17.753906 41.992188 C 17.390625 41.367188 16.722656 40.988281 16 41 L 11.828125 41 L 21.414063 31.414063 C 22.003906 30.839844 22.183594 29.960938 21.863281 29.199219 C 21.539063 28.441406 20.785156 27.957031 19.960938 27.980469 Z M 29.980469 27.980469 C 29.164063 27.980469 28.433594 28.476563 28.128906 29.230469 C 27.820313 29.984375 28.003906 30.847656 28.585938 31.414063 L 38.171875 41 L 34 41 C 33.277344 40.988281 32.609375 41.367188 32.246094 41.992188 C 31.878906 42.613281 31.878906 43.386719 32.246094 44.007813 C 32.609375 44.632813 33.277344 45.011719 34 45 L 45 45 L 45 34 C 45.007813 33.460938 44.796875 32.941406 44.414063 32.558594 C 44.03125 32.175781 43.511719 31.964844 42.96875 31.972656 C 41.867188 31.988281 40.984375 32.894531 41 34 L 41 38.171875 L 31.414063 28.585938 C 31.035156 28.199219 30.519531 27.980469 29.980469 27.980469 Z "
          />
          <path
            v-else
            title="Minimise"
            d="M 46.292969 2.292969 L 30 18.585938 L 30 9 L 28 9 L 28 22 L 41 22 L 41 20 L 31.414063 20 L 47.707031 3.707031 Z M 9 28 L 9 30 L 18.585938 30 L 2.292969 46.292969 L 3.707031 47.707031 L 20 31.414063 L 20 41 L 22 41 L 22 28 Z "
          />
        </svg>
      </a>
    </div>
    <div class="page__body" :class="{ loaded: loaded }">
      <iframe
        :scrolling="isMobile ? 'no' : 'yes'"
        frameborder="0"
        :src="page.url"
        @load="loaded = true"
        @loadeddata="loaded = true"
      ></iframe>
      <div class="wrapper"></div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    page: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isMobile: window.innerWidth < 750 ? true : false,
      loaded: false,
      fullWidth: false
    };
  },
  methods: {
    toggleFullWidth() {
      this.fullWidth = !this.fullWidth;
      setTimeout(() => {
        this.$el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center"
        });
      }, 100);
    },
    checkSize() {
      if (window.innerWidth < 750) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkSize);
  }
};
</script>

<style lang="scss" scoped>
.page {
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 0 0 0.5px rgba(3, 42, 60, 0.2), 0 0 0 1px rgba(3, 42, 60, 0.1),
    0 14px 28px rgba(3, 42, 60, 0.25), 0 10px 10px rgba(3, 42, 60, 0.22);
  transition: 0.3s all ease;
  width: 100%;
  height: 80vh;
  grid-column: span 1;

  @media (min-width: 794px) {
    &.full-width {
      grid-column: span 2;
      height: 95vh !important;
      width: 100%;
    }
  }

  .page__header {
    padding: 10px;
    display: flex;
    align-items: center;
    font-size: 0.9em;
    background: #323234;
    justify-content: space-between;
  }

  .page__button {
    width: 40px;
    height: 25px;
    // margin-right: 10px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    svg {
      height: 80%;
      fill: blanchedalmond;
      transition: 0.2s fill ease;
    }

    &:hover {
      svg {
        fill: $primary;
      }
    }
  }

  .page__searchbar {
    display: inline-flex;
    margin: 0 15px;
    width: 100%;
    max-width: calc(100% - 65px);
    justify-content: center;
    align-items: center;
    height: 25px;
    color: rgba(#fff, 0.7);
    text-decoration: none;
    border-radius: 50px;
    border: 1px solid #5a5a5c;
    transition: 0.2s color ease;
    background: #474749;
    cursor: pointer;

    &:hover {
      color: $primary;
    }
  }

  .page__body {
    position: relative;
    width: 100%;
    transition: 0.3s height ease;
    height: 100%;
    background: white;
    overflow: hidden;

    .wrapper {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: black;
      transition: 0.3s transform ease;
      transform: translateX(0%);

      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url("../assets/img/logo.svg") no-repeat center center;
        background-size: 40% 40%;
      }
    }

    &.loaded {
      .wrapper {
        transform: translateX(-100%);
      }
    }

    iframe {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
